import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HRS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="mx-auto mt-6 w-full max-w-xs sm:max-w-sm" data-id="element-28" data-mp="34qs24yo65gel">
      <p className="flex items-center justify-center gap-2 text-[11px] sm:text-xs font-bold uppercase tracking-[0.16em] text-ink-soft" data-id="element-29" data-mp="34pz0gc42hh3b">
        <ClockIcon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-30" data-mp="1c0yf03j29qvw" />
        This special offer ends in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-31" data-mp="1h0b3espkz60l">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-32" data-mp="171lvnsref1y2" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-33" data-mp="172dfk6bmvb8i">
              <div className="flex h-16 w-[68px] sm:h-[72px] sm:w-[78px] items-center justify-center rounded-xl bg-ink text-white shadow-[0_10px_24px_-14px_rgba(10,37,64,0.9)]" data-id="element-34" data-mp="1urg5s2kc2cem">
                <span className="font-display text-3xl sm:text-4xl font-bold tabular-nums" data-id="element-35" data-mp="1zs3vmkwtsn79">
                  {block.value}
                </span>
              </div>
              <span className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-36" data-mp="1pyveb7owgbe9">
                {block.label}
              </span>
            </div>
            {index < blocks.length - 1 ? <span className="-mt-5 font-display text-2xl font-bold text-ink/40" data-id="element-37" data-mp="2ii24h38g6kby">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}